import { render, staticRenderFns } from "./ModalGerenciarVagas.vue?vue&type=template&id=68e6645b"
import script from "./ModalGerenciarVagas.vue?vue&type=script&lang=js"
export * from "./ModalGerenciarVagas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports